import api from '../../../../api/client';


export const loanApplicationApi = {
  async getList(params = {}) {
    try {
      const response = await api.get('/self-service/loan-application/', { params });
      return {
        data: response.data.items || [],
        total: response.data.total_count || (response.data.items || []).length,
      };
    } catch (err) {
      console.warn('Failed to fetch loan applications:', err);
      return { data: [], total: 0 };
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/self-service/loan-application/${id}`);
      return { data: response.data };
    } catch (err) {
      console.warn(`Failed to fetch loan application #${id}:`, err);
      return { data: null };
    }
  },

  async getReasons() {
    try {
      const response = await api.get('/self-service/loan-application/reasons');
      return { data: response.data || [] };
    } catch (err) {
      console.warn('Failed to fetch loan reasons:', err);
      return { data: [] };
    }
  },

  async create(data) {
    const payload = {
      EmpId: data.EmpId || data.empId || 1,
      PayHeadID: data.PayHeadID || data.payHeadId || 1,
      LoanDate: data.LoanDate || data.loanDate || new Date().toISOString().split('T')[0],
      LoanAmt: Number(data.LoanAmt || data.loanAmount || data.amount || 10000),
      EMIAmt: Number(data.EMIAmt || data.emiAmount || 1000),
      EMIFromDate: data.EMIFromDate || data.emiFromDate || data.LoanDate || new Date().toISOString().split('T')[0],
      Remarks: data.Remarks || data.remarks || data.purpose || '',
      LoanType: Number(data.LoanType || data.loanTypeId || data.reasonId || 1),
      ApplyDate: data.ApplyDate || data.applyDate || new Date().toISOString().split('T')[0],
      Guarantor1ID: Number(data.Guarantor1ID || 0),
      Guarantor2ID: Number(data.Guarantor2ID || 0),
      IsApproved: 0,
      name: data.name,
      employeeId: data.employeeId || data.empId,
      loanType: data.loanType,
      tenureMonths: data.tenureMonths,
      purpose: data.purpose,
      status: 'Pending',
    };
    const response = await api.post('/self-service/loan-application/', payload);
    return { data: response.data.data, message: response.data.message || 'Loan application submitted' };
  },

  async update(id, data) {
    const payload = {
      EmpId: data.EmpId || data.empId,
      PayHeadID: data.PayHeadID || data.payHeadId,
      LoanDate: data.LoanDate || data.loanDate,
      LoanAmt: Number(data.LoanAmt || data.loanAmount || data.amount || 0),
      EMIAmt: Number(data.EMIAmt || data.emiAmount || 0),
      EMIFromDate: data.EMIFromDate || data.emiFromDate,
      Remarks: data.Remarks || data.remarks,
      LoanType: Number(data.LoanType || data.loanTypeId || 0),
      ApplyDate: data.ApplyDate || data.applyDate,
      name: data.name,
      employeeId: data.employeeId || data.empId,
      loanType: data.loanType,
      tenureMonths: data.tenureMonths,
      purpose: data.purpose,
      status: data.status,
    };
    const response = await api.put(`/self-service/loan-application/${id}`, payload);
    return { data: response.data.data, message: response.data.message || 'Loan application updated' };
  },

  async approve(id, isApproved) {
    const response = await api.post(`/self-service/loan-application/${id}/approve`, {
      is_approved: isApproved ? 1 : 2,
    });
    return { data: response.data, message: response.data.message };
  },

  async delete(id) {
    const response = await api.delete(`/self-service/loan-application/${id}`);
    return { success: response.data.success, message: response.data.message };
  },
};
